export default __webpack_public_path__ + "static/media/thumbs-up.047a5204.png";